import { render, staticRenderFns } from "./stFooter.vue?vue&type=template&id=a77535f8&scoped=true&"
import script from "./stFooter.vue?vue&type=script&lang=js&"
export * from "./stFooter.vue?vue&type=script&lang=js&"
import style0 from "./stFooter.vue?vue&type=style&index=0&id=a77535f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77535f8",
  null
  
)

export default component.exports